import type React from 'react';
import { NODE_ENV } from 'constants/node-env';
import { TIMEOUT_DELAY } from 'constants/general';

export const reportAccessibility = async (
  App: typeof React,
  config?: Record<string, unknown>
): Promise<void> => {
  if (
    typeof window === 'undefined' ||
    process.env.NODE_ENV === NODE_ENV.PRODUCTION
  ) {
    return;
  }

  const axe = await import('@axe-core/react');
  const ReactDOM = await import('react-dom');
  axe.default(App, ReactDOM, TIMEOUT_DELAY.DEFAULT, config);
};

export default reportAccessibility;
